import React from "react";
import { Card } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";

const CommentBox = ({ comments, setComments }) => {
  return (
    <div
      style={{
        position: "relative",
        padding: "10px 0",
        width: "100%",
        margin: "0 36px",
        // width: "100%",
      }}
    >
      <TextArea
        style={{
          width: "100%",
          borderRadius: 8,
          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
          height: "200px",
          borderColor: "#cccccc",
          padding: 10,
        }}
        value={comments}
        onChange={(e) => setComments(e.target.value)}
      />

      <div
        style={{
          position: "absolute",
          top: 0,
          left: "20px",
          background: "white",
          padding: "0 8px",
          //   transform: "translateY(-10%)",
        }}
      >
        <span style={{ fontWeight: "bold", fontSize: "12px" }}>Comments</span>
      </div>
      <div
        style={{
          position: "absolute",
          top: 0,
          right: "20px",
          background: "white",
          padding: "0 8px",
          transform: "translateY(-10%)",
          cursor: "pointer",
        }}
        onClick={() => setComments("")}
      >
        <DeleteOutlined style={{ color: "#8c8c8c" }} />
      </div>
    </div>
  );
};

export default CommentBox;
